document.addEventListener('change', (event) => {
  const toggle = event.target;
  if (!(toggle instanceof HTMLInputElement) || !toggle.matches('.rxk-gift [data-gift-schedule]')) return;
  if (!toggle.checked) {
    const date = toggle.closest('.rxk-gift__schedule').querySelector('input[type="date"]');
    date.value = '';
    date.dispatchEvent(new Event('input', { bubbles: true }));
    date.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
